import { render, staticRenderFns } from "./MobOverview.vue?vue&type=template&id=5372459a&scoped=true"
import script from "./MobOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./MobOverview.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobOverview.vue?vue&type=style&index=0&id=5372459a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5372459a",
  null
  
)

export default component.exports